// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  useClass: __t.string().primaryKey().name("use_class"),
  maxTris: __t.u32().name("max_tris"),
  maxTextures: __t.u16().name("max_textures"),
  maxTexturePx: __t.u16().name("max_texture_px"),
  maxMaterials: __t.u16().name("max_materials"),
  maxBones: __t.u16().name("max_bones"),
  maxNodes: __t.u16().name("max_nodes"),
  maxFileMb: __t.u16().name("max_file_mb"),
  maxVramMb: __t.u32().name("max_vram_mb"),
});
